import PropTypes from 'prop-types';
import styles from './Heading.module.scss';
import { testIds } from '../../../common/testData';

const Heading = (props) => {
    const { variant, text, className, onClick } = props;
    return <div onClick={() => { onClick && onClick() }} className={`${styles[variant]} ${className}`} data-testid={testIds['heading-component']}>{text}</div>
};

Heading.propTypes = {
    variant: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string
};

export default Heading;